import React, {useContext, useEffect, useState} from "react"
import ListGroup from "@common/ListGroup";
import useCurrentShortcut from "@hooks/useCurrentShortcut";
import {NavigationContext} from "@common/context/NavigationContext";
import axios from "@common/axios";
import ListItem from "@common/ListItem";

const FollowUpNavigation = () => {
    const { loadShortcutByUrl } = useCurrentShortcut();
    const { setNavVisible } = useContext(NavigationContext);
    const [ resultsData, setResultsData ] = useState();
    const [ itemCount, setItemCount ] = useState(null);

    useEffect(() => {
        if(!resultsData){
            axios.get('/web/ui/test/getStudentDiagnosticTestResults', {params: {feedbackComplete: false}})
                .then(response => setResultsData(response.data));
        }
    },[])

    const handleClick = () => {
        const shortcutUrl = '/web/ui/view/diagnostics/studentReports';
        loadShortcutByUrl(shortcutUrl);
        setNavVisible(false);

        if (globalReactFunctions && globalReactFunctions.handleTitleNavMenuClose) {
            globalReactFunctions.handleTitleNavMenuClose();
        }
    }

    return(
        <ListGroup isDisclosureItem={true} linkGroupId={'followUp-notifications-control'} title={'Follow-up work'} itemCount={resultsData?.length} disabled={false} startOpen={true}>
            {resultsData?.map(result => {
                return(
                    <ListItem isDisclosureItem={true} className={'ch-link'} key={result.testResultId} onClick={() => handleClick()}>
                        {result.testName}
                    </ListItem>
                )
            })}
        </ListGroup>
    )
}

export default FollowUpNavigation;